module.exports = __webpack_public_path__ + "static/media/Mailing-Clergy-FIRST-LETTER.dce5a265.docx";